// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"3886c415","460":"e9e27fc0","817":"b2fbbcaf","874":"c549b30a"}[chunkId] + ".chunk.css";
};